










































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { IPartnerCreateRequest, IPartnerUpdateRequest } from "@/types/partner";
import { IPartner } from "@/types/partner";
import { PartnerCreateRequest, PartnerUpdateRequest } from "@/models/partner";
import { IProceed, IProceedListRequest } from "@/types/proceed";
// import { ISelectItem } from "@/types";

@Component({})
export default class extends Vue {
  @Action("partner/salesGet")
  public getPartner!: (id: number) => Promise<void>;

  @Action("partner/salesCreate")
  public create!: (params: IPartnerCreateRequest) => Promise<boolean>;

  @Action("partner/salesUpdate")
  public update!: (data: {
    partner_id: number;
    params: IPartnerUpdateRequest;
  }) => Promise<boolean>;

  @Action("partner/salesDelete")
  public delete!: (partner_id: number) => Promise<boolean>;

  @Getter("partner/single")
  public partner!: IPartner;

  @Getter("error/error")
  public getError!: (key: string) => string[];

  @Action("proceed/salesGetList")
  public getProceeds!: (params: IProceedListRequest) => Promise<void>;

  @Getter("proceed/partnerProceeds")
  public partnerProceeds!: IProceed[];

  public partner_id = 0;
  public dialog = false;
  public params: IPartnerCreateRequest = new PartnerCreateRequest();

  private async created() {
    this.partner_id = Number(this.$route.params.partner_id);
    await this.getProceeds({ per_page: 0 });

    if (this.partner_id) {
      await this.getPartner(this.partner_id);
      this.params = new PartnerUpdateRequest(this.partner);
    } else {
      this.params.progress.push(
        ...this.partnerProceeds.map((proceed) => proceed.name)
      );
    }
  }

  public async submit() {
    let result = false;
    if (this.partner_id) {
      result = await this.update({
        partner_id: this.partner_id,
        params: this.params,
      });
    } else {
      result = await this.create(this.params);
    }
    if (result) {
      this.$router.go(-1);
    }
  }

  public async destroy(): Promise<void> {
    const result = await this.delete(this.partner_id);
    if (result) {
      this.$router.go(-1);
    }
  }

  public get rules(): { [key: string]: ((v: string) => true | string)[] } {
    const emailPattern =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;

    const telPattern = /^0\d{9,10}$/;

    return {
      name: [
        (v: string) => !!v || "担当者名は必須です",
        (v: string) => v.length <= 255 || "255文字以内で入力してください",
      ],
      uniqueid: [
        (v: string) => !!v || "ユニークIDは必須です",
        (v: string) => v.length <= 255 || "255文字以内で入力してください",
      ],
      email: [
        (v: string) => v.length <= 255 || "255文字以内で入力してください",
        (v: string) =>
          !v ||
          emailPattern.test(v) ||
          "メールアドレスを正しい形式で入力してください",
      ],
      tel: [
        (v: string) =>
          !v ||
          telPattern.test(v) ||
          "ハイフンなしの電話番号を半角数字で入力してください",
      ],
      address: [
        (v: string) => !v || v.length <= 255 || "255文字以内で入力してください",
      ],
      cutoff_date: [
        (v: string) => !v || Number(v) <= 28 || "28以下の数を入力してください",
        (v: string) => !v || 1 <= Number(v) || "1以上の数を入力してください",
      ],
    };
  }
}
